import { useOrderPanelStore } from '../../stores/order-panel-store'
import { PhoneNumber } from '../phone/PhoneNumber'

export function OrderPanelHeader() {
  const customer = useOrderPanelStore((s) => s.customer)
  const closePanel = useOrderPanelStore((s) => s.closePanel)

  if (!customer) return null

  return (
    <div className="flex items-start justify-between px-5 py-4 border-b border-slate-200 bg-slate-50">
      <div className="min-w-0">
        <h2 className="text-lg font-semibold text-slate-900 truncate">
          Nieuwe order
        </h2>
        <p className="text-sm text-slate-600 truncate">
          {customer.firstName} {customer.lastName}
        </p>
        <p className="text-xs text-slate-500 truncate">
          {[customer.street, customer.postcode, customer.city].filter(Boolean).join(', ')}
        </p>
        {(customer.phone || customer.email) && (
          <p className="text-xs text-slate-500 truncate mt-0.5">
            {customer.phone && (
              <PhoneNumber
                number={customer.phone}
                customerName={`${customer.firstName ?? ''} ${customer.lastName ?? ''}`.trim() || undefined}
                sourceContext="order-panel"
              />
            )}
            {customer.phone && customer.email ? ' / ' : ''}
            {customer.email}
          </p>
        )}
      </div>
      <button
        onClick={closePanel}
        className="p-1 text-slate-400 hover:text-slate-600 transition-colors flex-shrink-0"
      >
        <svg className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
        </svg>
      </button>
    </div>
  )
}
